import { render, staticRenderFns } from "./GMBProfileHistory.vue?vue&type=template&id=01bc5143&scoped=true"
import script from "./GMBProfileHistory.vue?vue&type=script&lang=js"
export * from "./GMBProfileHistory.vue?vue&type=script&lang=js"
import style0 from "./GMBProfileHistory.vue?vue&type=style&index=0&id=01bc5143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc5143",
  null
  
)

export default component.exports